module.exports = __webpack_public_path__ + "img/client-croxton.6897b34e.jpg";